export { ErrorBoundary, default, links, meta, shouldRevalidate } from "./root.tsx";